import { isZigzag } from '@common/device-manager';

import { isDomesticShippingUseCookie } from '../../../util/transformers/domestic-shipping-use-cookie-transformer';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq: (track: 'track', event: string, params?: any) => void;
  }
}

/**
 * Pixel Event: Description
 * ViewContent: 중요한 콘텐츠 페이지 방문, 조회한 페이지 관련 정보는 페이스북에 전달되어 다이내믹 광고에 사용
 * Search: 웹사이트에서 발생한 검색 (예. 제품검색 등)
 * AddToWishlist: 위시리스트에 제품 추가
 * AddToCart: 장바구니에 제품 추가
 * InitiateCheckout: 결제 프로세스 시작
 * AddPaymentInfo: 결제 프로세스 중 고객 정보 추가
 * Purchase: 구매 완료, 거래 영수증 표시
 * Subscribe: 제품 혹은 유료 서비스 구독
 * StartTrial: 무료 서비스 이용 시작
 * CompleteRegistration: 이메일 받아보기 신청 등의 비즈니스에서 제공하는 서비스를 이용하는 조건으로 정보 제출
 * Contact: 전화, SMS, 이메일, 채팅 등을 통한 연락 발생
 */
export enum FbPixelEventEnum {
  ViewContent = 'ViewContent',
  Search = 'Search',
  AddToWishlist = 'AddToWishlist',
  AddToCart = 'AddToCart',
  InitiateCheckout = 'InitiateCheckout',
  AddPaymentInfo = 'AddPaymentInfo',
  Purchase = 'Purchase',
  Subscribe = 'Subscribe',
  StartTrial = 'StartTrial',
  CompleteRegistration = 'CompleteRegistration',
  Contact = 'Contact',
}

export const trackFbPixel = (event: FbPixelEventEnum, params?: any) => {
  if (!isZigzag() && window.fbq !== undefined && isDomesticShippingUseCookie()) {
    window.fbq('track', event, params);
  }
};
